import { Skeleton } from '@mui/material';

import { Cell, CellLabel, CellValue } from '../styles';

const StudentResponsesSkeleton = () => {
  return (
    <Cell>
      <CellLabel>
        <Skeleton variant="text" width={100} />
      </CellLabel>
      <CellValue>
        <Skeleton variant="text" width={100} />
      </CellValue>
    </Cell>
  );
};

export default StudentResponsesSkeleton;
